'use client';
import React from 'react';
import Modal from 'react-modal';
import MWSVG from './svg';
import { InlineWidget } from 'react-calendly';

const ScheduleCall = () => {
    const customStyles = {
        overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.6)',
            padding: 0,
        },
        content: {
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#fff',
            border: '0',
            maxWidth: '600px',
            width: '90%',
            padding: '0',
            paddingTop: '20px',
        },
    };

    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <>
            <button
                className="btn btn-primary self-baseline"
                aria-labelledby="callLabel"
                onClick={() => {
                    openModal();
                }}
            >
                Schedule a Call
            </button>
            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
                <div onClick={closeModal} className="text-secondary text-right btn-close absolute left-5 cursor-pointer pt-5">
                    <MWSVG id="ic_close" svgClassName="text-secondary" />
                </div>
                <InlineWidget
                    styles={{
                        height: '100%',
                    }}
                    url="https://calendly.com/mowebsales/moweb-sales"
                />
            </Modal>
        </>
    );
};

export default ScheduleCall;
